import { useEffect, useRef } from "react";
import { useNavigation } from "react-router";
import { trackEvent } from "~/lib/gtag";
import { PERFORMANCE_TARGETS } from "~/lib/performance-targets";

export function NavigationProgress() {
	const navigation = useNavigation();
	const startedAt = useRef<number | null>(null);

	useEffect(() => {
		if (navigation.state !== "idle" && startedAt.current === null) {
			startedAt.current = performance.now();
			return;
		}

		if (navigation.state === "idle" && startedAt.current !== null) {
			const durationMs = Math.round(performance.now() - startedAt.current);
			startedAt.current = null;
			trackEvent("navigation_timing", { duration_ms: durationMs });
		}
	}, [navigation.state]);

	if (navigation.state === "idle") return null;

	return (
		<>
			<div
				className="fixed inset-x-0 top-0 z-[100] h-1 overflow-hidden bg-primary/20"
				role="progressbar"
				aria-label="Načítám stránku"
				data-feedback-target-ms={PERFORMANCE_TARGETS.navigationFeedbackMs}
			>
				<div className="h-full w-2/3 animate-pulse rounded-r-full bg-primary" />
			</div>
			<output className="sr-only" aria-live="polite">
				Načítám stránku…
			</output>
		</>
	);
}
